<template>
    <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <div class="sm:flex sm:items-center sm:justify-between">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Suas Solicitações</h3>
                <div class="mt-3 sm:mt-0 sm:ml-4">
                    <button @click="openModal" type="button" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Nova Solicitação
                    </button>
                </div>
            </div>
            <div class="mt-5 border-t border-gray-200 overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrição</th>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200" v-if="!loading">
                        <tr v-for="solicitacao in solicitacoes" :key="solicitacao.id">
                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ solicitacao.tipo_solicitacao }}</td>
                            <td class="px-6 py-4 text-sm text-gray-500 truncate max-w-xs">{{ solicitacao.descricao }}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                    {{ solicitacao.status }}
                                </span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ new Date(solicitacao.created_at).toLocaleDateString('pt-BR') }}</td>
                        </tr>
                    </tbody>
                </table>
                 <div v-if="loading" class="text-center p-6 text-gray-500">Buscando solicitações...</div>
            </div>
        </div>

        <!-- Fake Modal for Nova Solicitação -->
        <div v-if="showModal" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="closeModal"></div>
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                    <div>
                        <div class="mt-3 text-left sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Abrir Nova Solicitação</h3>
                            <div class="mt-2">
                                <label class="block text-sm font-medium text-gray-700">Assunto / Tipo</label>
                                <select v-model="nova.tipo_solicitacao" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                                    <option value="Aumento de Capital">Aumento de Capital</option>
                                    <option value="Solicitação de Documento">Solicitação de Documento</option>
                                    <option value="Cancelamento">Cancelamento</option>
                                    <option value="Outro">Outro</option>
                                </select>
                            </div>
                            <div class="mt-4">
                                <label class="block text-sm font-medium text-gray-700">Descrição</label>
                                <textarea v-model="nova.descricao" rows="4" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <button @click="salvar" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none sm:col-start-2 sm:text-sm">
                            Enviar
                        </button>
                        <button @click="closeModal" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:col-start-1 sm:text-sm">
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClientPortalRepository from '@/services/ClientPortalRepository.vue';
import Swal from 'sweetalert2';

export default {
    name: 'ClienteSolicitacoesView',
    data() {
        return {
            loading: true,
            solicitacoes: [],
            service: new ClientPortalRepository(),
            showModal: false,
            nova: {
                tipo_solicitacao: 'Aumento de Capital',
                descricao: ''
            }
        }
    },
    async mounted() {
        await this.carregarSolicitacoes();
    },
    methods: {
        async carregarSolicitacoes() {
            this.loading = true;
            try {
                const res = await this.service.getSolicitacoes();
                this.solicitacoes = res.data;
            } catch (error) {
                console.error("Erro", error);
            } finally {
                this.loading = false;
            }
        },
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.nova.descricao = '';
        },
        async salvar() {
            if(!this.nova.descricao) return alert("Preencha a descrição!");
            
            try {
                await this.service.createSolicitacao(this.nova);
                Swal.fire('Sucesso!', 'Solicitação enviada com sucesso.', 'success');
                this.closeModal();
                this.carregarSolicitacoes(); // Recarrega
            } catch(e) {
                Swal.fire('Erro', 'Houve um problema.', 'error');
            }
        }
    }
}
</script>
